import { CustomPageQuery } from '../generated/types';

export const findSectionModules = (data: CustomPageQuery | undefined, section: string) =>
  data?.displayPage?.targetBuckets.find(({ name }) => name === section);
